var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextSlideKitaOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.44 15.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002d55;}.cls-2{fill:#b4c3d6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kitapilot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.72,
    cy: 7.72,
    r: 7.72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.73,
    y: 7.6,
    width: 7.89,
    height: 0.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.53 3.37 11.88 7.72 7.53 12.07 7.36 11.9 11.54 7.72 7.36 3.54 7.53 3.37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSlideKitaOverview);
export default __webpack_public_path__ + "static/media/nextSlideKitaOverview.703d1e7b69f5fde7fb74b111a66926b2.svg";
export { ForwardRef as ReactComponent };